import React,{useRef,useState,useEffect} from 'react';
import styled from 'styled-components'
import cn from 'classnames'

const Article5Block = styled.div`
z-index: -1;
  width: 100vw;
  height: 4000px;
  background-image: url('images/spacebackground.jpg');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  .img {
    position: absolute;
  }
  .img1 {top:10%; left:10%; width:250px;}
  .img2 {top:20%; right:5%; width:300px;}
  .img3 {top:30%; left:15%; width:200px;}
  .img4 {top:40%; right:5%; width:250px;}
  .img5 {top:50%; left:10%; width:300px;}
  .img6 {top:60%; right:10%; width:200px;}
  .img7 {top:70%; left:5%; width:250px;}
  .img8 {top:80%; right:10%; width:300px;}
  .out {
    width: 100vw;
    height: 100vh;
    &.on {
      position: fixed;
      top: 0;
      height: 100vh;
    }
    .inner {
      width: 1170px;
      height: 100vh;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      align-items: center;
      .square {
        width: 400px;
        height: 400px;
        position: relative;
        transform-style: preserve-3d;
        video {
          width: 100%;
          height: 100%;
          position: absolute;
          &:nth-child(1) {transform:translateZ(200px)}
          &:nth-child(2) {transform: rotateX(180deg) translateZ(200px)}
          &:nth-child(3) {transform: rotateX(-90deg) translateZ(200px)}
          &:nth-child(4) {transform: rotateX(90deg) translateZ(200px)}
        }
      }
    }
  }
  
`;


const Article5 = () => {

  const thisTop = useRef();
  const squareRef = useRef(null);
  const [on, setOn] = useState(false);

  const onScroll = () => { 
    const art4offTop = thisTop.current.offsetTop;
    const scroll = window.scrollY - art4offTop;
    if (squareRef.current) squareRef.current.style.transform = `rotate3d(1,0,0,${scroll/5}deg)`;
    if (art4offTop <= window.scrollY && art4offTop + 4000 >= window.scrollY) {
      setOn(true);
    } else {
      setOn(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  
  return (
    <Article5Block ref={thisTop}>
      <img className='img img1' src="images/art5poster1.jpeg" alt=""/>
      <img className='img img2' src="images/art5poster2.jpeg" alt=""/>
      <img className='img img3' src="images/art5poster3.jpeg" alt=""/>
      <img className='img img4' src="images/art5poster4.jpeg" alt=""/>
      <img className='img img5' src="images/lookbook1.jpeg" alt=""/>
      <img className='img img6' src="images/lookbook2.jpeg" alt=""/>
      <img className='img img7' src="images/lookbook3.jpeg" alt=""/>
      <img className='img img8' src="images/lookbook4.jpg" alt=""/>
      <div className={cn({on},'out')}>
        <div className='inner' style={{perspective:'1000px'}}>
          <div className='square' ref={squareRef}>
            <video playsInline={true} autoPlay={true} loop={true} muted={true} style={{}} >
              <source src="videos/short1.mp4" type="video/mp4" />
            </video>
            <video playsInline={true} autoPlay={true} loop={true} muted={true} style={{}}>
              <source src="videos/short2.mp4" type="video/mp4" />
            </video>
            <video playsInline={true} autoPlay={true} loop={true} muted={true} style={{}}>
              <source src="videos/short3.mp4" type="video/mp4" />
            </video>
            <video playsInline={true} autoPlay={true} loop={true} muted={true} style={{}}>
              <source src="videos/short4.mp4" type="video/mp4" />
            </video>
          </div>
        </div>
      </div>
    </Article5Block>
  );
};

export default Article5;